import * as React from 'react';
import { ConnectionDegree } from '@xingternal/badge';
import { SuperEllipse } from '@xingternal/super-ellipse';
import { mapProfileSizetoBadgeSize } from '../util/map-profile-size-to-badge-size';
import { ProfileImageResponsive } from '..';
import { Styled } from './profile-image.styles';
export const ProfileImage = ({ className, connectionDegree, size, sizeConfined, sizeWide, sizeXWide, variant, ...props }) => {
    const connectionDegreeSize = mapProfileSizetoBadgeSize(size);
    const connectionDegreeSizeConfined = mapProfileSizetoBadgeSize(sizeConfined);
    const connectionDegreeSizeWide = mapProfileSizetoBadgeSize(sizeWide);
    const connectionDegreeSizeXWide = mapProfileSizetoBadgeSize(sizeXWide);
    if (variant === 'responsive') {
        return (React.createElement(ProfileImageResponsive, { connectionDegree: connectionDegree, ...props }));
    }
    return (React.createElement(Styled.Container, { className: className, "$size": size, "$sizeConfined": sizeConfined, "$sizeWide": sizeWide, "$sizeXWide": sizeXWide },
        React.createElement(SuperEllipse, { size: size, sizeConfined: sizeConfined, sizeWide: sizeWide, sizeXWide: sizeXWide, ...props }),
        Boolean(connectionDegree) && (React.createElement(Styled.BadgeContainer, { "$size": size, "$sizeConfined": sizeConfined, "$sizeWide": sizeWide, "$sizeXWide": sizeXWide },
            React.createElement(ConnectionDegree, { size: connectionDegreeSize, sizeConfined: connectionDegreeSizeConfined, sizeWide: connectionDegreeSizeWide, sizeXWide: connectionDegreeSizeXWide }, connectionDegree)))));
};
ProfileImage.displayName = 'ProfileImage';
//# sourceMappingURL=profile-image.js.map